import * as React from "react";
import { SVGProps } from "react";
const SvgMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 9h21c.8 0 1.5-.7 1.5-1.5S27.3 6 26.5 6h-21C4.7 6 4 6.7 4 7.5S4.7 9 5.5 9Zm21 13h-21c-.8 0-1.5.7-1.5 1.5S4.7 25 5.5 25h21c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5Zm0-8h-21c-.8 0-1.5.7-1.5 1.5S4.7 17 5.5 17h21c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMenu;
